import React from 'react';
import PropTypes from 'prop-types';
import SelectableCard from '../SelectableCard';

/**
 * SelectableCardGroup Molecule - grupa kart z możliwością wyboru
 * Obsługuje layout i zarządzanie stanem wybranej opcji
 */
const SelectableCardGroup = ({
  options = [],
  selectedId,
  onSelect,
  columns = 3,
  className = '',
  ...props
}) => {
  const gridClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
  };

  const containerClasses = [
    'grid gap-4',
    gridClasses[columns] || gridClasses[3],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} {...props}>
      {options.map((option) => (
        <SelectableCard
          key={option.id}
          id={option.id}
          title={option.title}
          description={option.description}
          icon={option.icon}
          selected={selectedId === option.id}
          disabled={option.disabled}
          hidden={option.hidden}
          comingSoon={option.comingSoon}
          onClick={onSelect}
        />
      ))}
    </div>
  );
};

SelectableCardGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      icon: PropTypes.elementType,
      disabled: PropTypes.bool,
      hidden: PropTypes.bool,
      comingSoon: PropTypes.bool,
    })
  ).isRequired,
  selectedId: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  columns: PropTypes.oneOf([1, 2, 3, 4]),
  className: PropTypes.string,
};

export default SelectableCardGroup;
